function CloseIcon({ width, height, fill }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.41406 6.58594L6.58594 9.41406L21.1719 24L6.58594 38.5859L9.41406 41.4141L24 26.8281L38.5859 41.4141L41.4141 38.5859L26.8281 24L41.4141 9.41406L38.5859 6.58594L24 21.1719L9.41406 6.58594Z"
        fill={fill}
      />
    </svg>
  );
}

export default CloseIcon;
